import Carousel from 'react-multi-carousel'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'
import { StyledUtils } from '@ocean/utils'

const { Icon } = common

export const AnimatedBanner = styled.div`
  transition: max-height 1s ease-out;
  position: relative;

  &.banner-enter {
    max-height: 0;
  }
  &.banner-enter-active {
    max-height: 200px;
  }
  &.banner-exit {
    transition: max-height 0.2s ease-out;
    max-height: 200px;
  }
  &.banner-exit-active {
    max-height: 0;
  }
`

export const Wrapper = styled.div`
  min-height: 50px;

  ${({ theme }) => `
    background-color: ${theme.color.cornflower};
    color: ${theme.color.black};
    font-family: ${theme.fontFamily.secondary};
    font-weight: ${theme.fontWeight.normal};
    padding: ${theme.space.mobile.tiny} ${theme.space.mobile.base};
    padding-right: ${theme.space.mobile.large};

    svg{
      fill: ${theme.color.black};
    }
  `}

  ${({ theme }) => media.sm`
    padding: calc(${theme.space.desktop.nano} * 2) ${theme.space.desktop.small};
    padding-right: ${theme.space.desktop.base};
  `}
  
  ${media.lg`
    justify-content: space-between;
    display: flex;
    align-items: center;
  `}

  /* Join button */
  button[data-selector='Button'] {
    flex-shrink: 0;

    ${({ theme }) => `
      padding: ${theme.space.mobile.tiny};
      margin-right: ${theme.space.mobile.base};
    `}
  }
`

export const InfoIcon = styled(Icon)`
  flex-shrink: 0;
  display: none;

  ${({ theme }) => `
    width: calc(${theme.space.mobile.base} + ${theme.space.mobile.nano});
    margin-right: ${theme.space.mobile.tiny};
  `}

  ${media.lg`  
    display: block; 
  `}
`

export const JoinWrapper = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.nano};
  `}

  ${media.lg`
    margin-top: 0;
  `}
`

export const CloseButton = styled.button`
  ${StyledUtils.clearButton}
  position: absolute;
  display: flex;
  justify-content: flex-end;

  ${media.lg`
    align-items: center;
  `}

  ${({ theme }) => `
    width:  ${theme.space.mobile.large}; 
    height: ${theme.space.mobile.large}; 
    top: calc(${theme.space.desktop.nano} * 2);
    right: ${theme.space.mobile.base}; 

    svg {
      width: ${theme.space.mobile.small}; 
      height: ${theme.space.mobile.small}; 
      
      g {
        stroke: ${theme.color.black};
      }
    }
  `}
`

export const CarouselContainer = styled(Carousel)`
  flex-grow: 1;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.tiny};
  `}

  ${({ theme }) => media.lg`
    margin-right: ${theme.space.mobile.base};
  `}
`
